// WebAudio synthesis engine — no external audio files needed

let audioCtx: AudioContext | null = null;

function getCtx(): AudioContext {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
  }
  return audioCtx;
}

function playTone(
  frequency: number,
  duration: number,
  type: OscillatorType = 'sine',
  gainVal = 0.3,
  startDelay = 0
): void {
  try {
    const ctx = getCtx();
    const osc = ctx.createOscillator();
    const gainNode = ctx.createGain();
    osc.connect(gainNode);
    gainNode.connect(ctx.destination);
    osc.type = type;
    osc.frequency.setValueAtTime(frequency, ctx.currentTime + startDelay);
    gainNode.gain.setValueAtTime(gainVal, ctx.currentTime + startDelay);
    gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + startDelay + duration);
    osc.start(ctx.currentTime + startDelay);
    osc.stop(ctx.currentTime + startDelay + duration);
  } catch { /* noop */ }
}

export function playWin(): void {
  playTone(523, 0.12, 'sine', 0.25, 0);
  playTone(659, 0.12, 'sine', 0.25, 0.1);
  playTone(784, 0.25, 'sine', 0.3, 0.2);
}

export function playLose(): void {
  playTone(300, 0.08, 'sawtooth', 0.2, 0);
  playTone(220, 0.12, 'sawtooth', 0.2, 0.08);
  playTone(160, 0.3, 'sawtooth', 0.25, 0.18);
}

export function playTap(): void {
  playTone(800, 0.06, 'sine', 0.15, 0);
}

export function playCountdown(): void {
  playTone(440, 0.08, 'square', 0.1, 0);
}

export function playGameStart(): void {
  playTone(440, 0.08, 'sine', 0.15, 0);
  playTone(550, 0.1, 'sine', 0.15, 0.08);
}

export function playStreakUp(): void {
  playTone(880, 0.08, 'sine', 0.2, 0);
  playTone(1100, 0.15, 'sine', 0.25, 0.06);
}

export function haptic(pattern: number | number[] = 50): void {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
}